import { createFileRoute } from "@tanstack/react-router";
import { CreateCookie, EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management/create/")({
  component: () => (
    <EditContent>
      <CreateCookie />
    </EditContent>
  ),
});

export { Route };
